import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilPager } from "../../../utils/utilPager";
import { actionGameTrackingShopProviderNavigate } from "../../game-tracking/shop/actionGameTrackingShop";
import { ButtonPaymentSelectPagerLeft } from "../../generic/common/ButtonPaymentSelectPagerLeft";
import { ButtonPaymentSelectPagerRight } from "../../generic/common/ButtonPaymentSelectPagerRight";
import { List } from "../../generic/list/List";
import { Pager } from "../../generic/pager/Pager";
import { TextLoca } from "../../generic/text/TextLoca";
import { ShopPaymentProvider } from "./ShopPaymentProvider";
var ProviderPerPage = 6;
var _ShopPaymentProviderSelection = function (_a) {
    var shopPackage = _a.shopPackage, providers = _a.providers, onProviderSelected = _a.onProviderSelected, onProviderNavigate = _a.onProviderNavigate, selectedProvider = _a.selectedProvider;
    var renderProvider = function (provider) {
        var isSelected = provider.id === selectedProvider.id;
        return (React.createElement(ShopPaymentProvider, { provider: provider, isSelected: isSelected, onClick: onProviderSelected, key: provider.id + "_" + provider.countryCode }));
    };
    var renderPage = function (page, changePage) {
        var items = utilPager.getPageItems(providers, page, ProviderPerPage);
        return (React.createElement("div", { className: "shop-psp__pager-container" },
            React.createElement(ButtonPaymentSelectPagerLeft, { onClick: function () {
                    if (onProviderNavigate) {
                        onProviderNavigate();
                    }
                    changePage(page - 1);
                } }),
            React.createElement(List, { items: items, renderItem: renderProvider, className: "shop-psp__provider-list-container" }),
            React.createElement(ButtonPaymentSelectPagerRight, { onClick: function () {
                    if (onProviderNavigate) {
                        onProviderNavigate();
                    }
                    changePage(page + 1);
                } })));
    };
    var pageCount = Math.ceil(providers.length / ProviderPerPage);
    return (React.createElement("div", { className: "shop-psp__selection-container" },
        React.createElement(TextLoca, { id: IdLoca.purchase_paymentMethod_web, className: IdStyles.TextNormal + " ml__large" }),
        React.createElement(Pager, { pageCount: pageCount }, renderPage)));
};
var mapDispatch = function (dispatch) { return ({
    onProviderNavigate: function () { return dispatch(actionGameTrackingShopProviderNavigate()); },
}); };
export var ShopPaymentProviderSelection = connect(undefined, mapDispatch)(_ShopPaymentProviderSelection);



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/ShopPaymentProviderSelection.tsx
// module id = 2920
// module chunks = 3